<template>

<div>
    <aside class="is-hidden-touch">
        <div class="sidebar-brand">
            <img :src="require('../../assets/images/cropped-logotipo-bambi.png')" alt="logo" class="logo">
        </div>
        <div class="sidebar-inner">
            <ul class="top-menu">
                <li>
                    <router-link tag="a" :to="{name: 'profile'}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24"
                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="feather feather-home">
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                            <polyline points="9 22 9 12 15 12 15 22"></polyline>
                        </svg>
                        <span>Inicio</span>
                    </router-link>
                </li>

                <li class="main-sub-item">
                    <a @click="clickMyAccount">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24"
                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="feather feather-user">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                            <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                        <span>Mi Cuenta</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24"
                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down right-icon"
                            v-show="!myAccountActive"> >
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24"
                            height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up right-icon"
                            v-show="myAccountActive">
                            <polyline points="18 15 12 9 6 15"></polyline>
                        </svg>

                    </a>
                </li>

                <li class="sub-item" :class="{'is-hidden': !myAccountActive}">
                    <router-link tag="a" :to="{name: 'account.status'}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="feather feather-credit-card">
                            <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                            <line x1="1" y1="10" x2="23" y2="10"></line>
                        </svg>
                        <span>ESTADO DE CUENTA</span>
                    </router-link>
                </li>
                <li>
                    <a href="#" @click.prevent="signOut">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="feather feather-log-out">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                        </svg>
                        <span>SALIR</span>
                    </a>
                </li>
            </ul>
        </div>
    </aside>
    <!-- <sidebar></sidebar> -->

    <!-- END NAV -->
    <transition name="slide-down" mode="out-in">
        <error></error>
    </transition>

    <transition name="slide-down" mode="out-in">
        <primary></primary>
    </transition>

    <!-- <main> -->
        <!-- MAIN -->
        <transition name="fade" mode="out-in">
            <router-view/>
        </transition>
        <!-- END MAIN -->
    <!-- </main> -->

        <div id="quickview-trigger" class="menu-fab is-hidden-desktop">
            <a class="hamburger-btn" @click="clickBurgerMenu">
                <span class="menu-toggle">
                        <span class="icon-box-toggle" :class="{active: burgerMenuClicked}">
                            <span class="rotate">
                                <i class="icon-line-top"></i>
                                <i class="icon-line-center"></i>
                                <i class="icon-line-bottom"></i>
                            </span>
                </span>
                </span>
            </a>
        </div>

        <div class="category-quickview is-hidden-desktop" :class="{'is-active': sidebarIsActive}">
            <div class="brand">
                <img :src="require('../../assets/images/cropped-logotipo-bambi.png')" alt="logo" class="logo">
            </div>
            <div class="inner">
                <ul class="category-menu">
                                    <li>
                            <router-link tag="a" :to="{name: 'profile'}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                    height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" class="feather feather-home">
                                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                                </svg>
                                <span>Inicio</span>
                            </router-link>
                        </li>

                        <li>
                            <router-link tag="a" :to="{name: 'account.status'}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                    class="feather feather-credit-card">
                                    <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                                    <line x1="1" y1="10" x2="23" y2="10"></line>
                                </svg>
                                <span>ESTADO DE CUENTA</span>
                            </router-link>
                        </li>

                        <li v-show="user.level > 0">
                            <router-link tag="a" :to="{name: 'users'}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                    class="feather feather-users">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="9" cy="7" r="4"></circle>
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                </svg>

                                <span>USUARIOS</span>
                            </router-link>
                        </li>

                        <li>
                            <a href="#" @click.prevent="signOut">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" class="feather feather-log-out">
                                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                    <polyline points="16 17 21 12 16 7"></polyline>
                                    <line x1="21" y1="12" x2="9" y2="12"></line>
                                </svg>
                                <span>SALIR</span>
                            </a>
                        </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import error from '../components/notificacion/error'
import primary from '../components/notificacion/primary'
// import sidebar from '../components/sidebar'

export default {
    name: 'home',
    data() {
        return {
                burgerMenuClicked: false,
                sidebarIsActive: false,
                myAccountActive: false,
        }
    },
    computed: {
        ...mapGetters({
            authenticated: 'auth/authenticated',
            user: 'auth/user',
            customer: 'customer/customer',
            errors: 'auth/errors'
        }),
    },
    components: {
        error, primary, //sidebar
    },
    watch: {
        '$route' () {
            this.burgerMenuClicked = false
            this.sidebarIsActive = false
        }
    },
    methods: {
        ...mapActions({
            signOutAction: 'auth/signOut',
        }),
        clickBurgerMenu() {
            this.burgerMenuClicked = !this.burgerMenuClicked
            this.sidebarIsActive   = !this.sidebarIsActive
        },
        clickMyAccount() {
            this.myAccountActive   = !this.myAccountActive
        },
        signOut() {
            this.signOutAction().then(() => {
                this.$router.replace({
                    name: 'auth.login'
                })
            })
        },
    }
}
</script>

<style>
.section{
    padding: 1.2rem 1.5rem;
}

@media (max-width: 1024px) {
    .menu-fab {
        top: 20px !important;
        right: 20px !important;
    }
    .category-quickview .inner .category-menu li a svg{
        fill: none;
    }
    .category-quickview .brand img{
        padding: 75px 30px 0px;
    }
    .category-quickview .inner .category-menu{
        padding: 30px 0px 0px;
    }


}
</style>